// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1j37Q","loadingShrink":"PageLoading_loadingShrink__3vmoy"};